var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSelect = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12px",
  height: "8px",
  viewBox: "0 0 12 8",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.247 6.596a.943.943 0 0 0-.065 1.193l.098.112 3.642 3.552.258.231c.472.422 1.175.421 1.645-.003l.253-.228 5.644-5.866a.937.937 0 0 0 .124-1.181l-.094-.12a.886.886 0 0 0-1.274-.031L7.001 9.96 3.518 6.562a.882.882 0 0 0-1.271.034Z",
  transform: "translate(-809.000000, -620.000000) translate(806.000000, 615.000000) translate(1.000000, 1.000000)",
  fillRule: "evenodd"
})));

export default SvgSelect;